import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface TableResult {
  Columns: string[];
  Rows: Record<string, unknown>[];
  RowCount : number;
}

export interface QueryResult {
  Tables : TableResult[];
  TotalQueries : number;
}

@Injectable({
  providedIn: 'root'
})
export class QueryBuilderService {
 private apiUrl = '/api/gtqryrslt';
 private exportUrl = '/api/genrtqryrsltxls';
  constructor(
    private http: HttpClient
  ) { }

  execute(query: string): Observable<any> {
    return this.http.post<any>(this.apiUrl, { query });
  }

  
    exportToExcel(query: string): Observable<Blob> {
    return this.http.post(
      this.exportUrl,
      { query },
      {
        responseType: 'blob'
      }
    );
  }
}
